import React from 'react';
import classNames from 'classnames/bind';
import CDNImage from '../../utils/CDNImage';
import HoverCard from '../../components/Hover/HoverCard';

import styles from './We.module.scss';

let cx = classNames.bind(styles);

const We = () => {
	return (
		<section id='nosotros' className={cx({ we: true })}>
			<div className='container mx-auto flex flex-col p-2 lg:p-0'>
				<h1 className='text-tcn-dark-blue font-bold font-Avenir-Black text-4xl lg:text-5xl py-4 text-center lg:text-left'>
					NOSOTROS
				</h1>
				<div className='w-full flex flex-col lg:flex-row'>
					<div className='flex flex-col w-full lg:w-1/4 mx-2 pt-6 lg:pt-12'>
						<CDNImage
							className='w-full px-8 lg:px-0'
							image_name={'proposito.png'}
							alt='proposito'
						/>
						<p className='font-Avenir-Black text-tcn-black text-xl text-center px-6 py-4'>
							Construir una empresa sustentable, altamente productiva y
							plenamente humana.
						</p>
					</div>

					<div className='flex flex-col w-full lg:w-1/4 mx-2 pt-6 lg:pt-12'>
						<CDNImage
							className='w-full px-8 lg:px-0'
							image_name={'mision.png'}
							alt='mision'
						/>
						<p className='font-Avenir-Black text-tcn-dark-blue text-xl text-center px-6 py-4'>
						Alimentos deliciosos y nutritivos en las manos de todos.
						</p>
					</div>

					<div className='flex flex-col w-full lg:w-1/4 mx-2 pt-6 lg:pt-12'>
						<CDNImage
							className='w-full px-8 lg:px-0'
							image_name={'Vision.png'}
							alt='Vision'
						/>
						<p className='font-Avenir-Black text-tcn-black text-xl text-center px-6 py-4'>
							En 2020{' '}
							<strong className='text-tcn-red font-bold font-Avenir-Black'>
								transformamos
							</strong>{' '}
							la industria de la panificación y{' '}
							<strong className='text-tcn-red font-bold font-Avenir-Black'>
								expandimos
							</strong>{' '}
							nuestro liderazgo global para servir mejor a más consumidores.
						</p>
					</div>

					<div className='flex flex-col w-full lg:w-1/4 mx-2'>
						<CDNImage
							className='w-full px-8 lg:px-0'
							image_name={'Osito_cuchi.png'}
							alt='Osito_cuchi'
						/>
					</div>
				</div>
			</div>
			<div className='container mx-auto hidden lg:flex flex-col '>
				<h1
					className={cx({
						our_beliafs: true,
						'text-tcn-red font-bold font-Avenir-Black text-5xl py-4 leading-none': true,
					})}
				>
					NUESTRAS <br /> CREENCIAS
				</h1>
				<div className='w-full flex flex-col lg:flex-row'>
					<div className='flex flex-col w-full mx-2 pt-12 justify-center items-center'>
						<CDNImage className='w-full' image_name={'trigo.png'} alt='trigo' />
					</div>
				</div>
			</div>
			<div className='container mx-auto flex flex-col p-4 lg:p-0'>
				<h1
					className={cx({
						'text-tcn-dark-blue font-bold font-Avenir-Black text-3xl lg:text-4xl py-4 text-center lg:text-left ': true,
					})}
				>
					En nuestra operación de{' '}
					<strong className='text-tcn-red font-Avenir-Black'>Chile</strong>{' '}
					tenemos:
				</h1>
				<div className='w-full flex lg:flex-row flex-wrap lg:flex-no-wrap'>
					<div className='flex flex-col w-1/2 lg:w-1/5 lg:mx-8 pt-4 lg:pt-12 justify-center items-center'>
						<CDNImage className='w-full px-2 lg:px-0' image_name={'2b.png'} alt='s' />
						<p
							className={cx({
								box_p: true,
								'text-white text-base px-3 lg:px-6 font-bold text-center': true,
							})}
						>
							PLANTAS DE PRODUCCIÓN{' '}
						</p>
					</div>
					<div className='hidden lg:flex flex-col w-1/2 lg:w-1/5 lg:mx-8 pt-12 justify-center items-center'>
						<CDNImage
							className='w-full px-2 lg:px-0'
							image_name={'masde100b.png'}
							alt='masde100'
						/>
						<p
							className={cx({
								box_p: true,
								'text-white text-base px-3 lg:px-6 font-bold text-center': true,
							})}
						>
							PRODUCTOS <br />
							<br />{' '}
						</p>
					</div>
					<div className='hidden lg:flex flex-col w-1/2 lg:w-1/5 lg:mx-8 pt-12 justify-center items-center'>
						<CDNImage className='w-full px-2 lg:px-0' image_name={'19b.png'} alt='19' />
						<p
							className={cx({
								box_p: true,
								'text-white text-base px-3 lg:px-6 font-bold text-center': true,
							})}
						>
							LÍNEAS DE PRODUCCIÓN
						</p>
					</div>
					<div className='flex flex-col w-1/2 lg:w-1/5 lg:mx-8 pt-4 lg:pt-12 justify-center items-center'>
						<CDNImage className='w-full px-2 lg:px-0' image_name={'2000b.png'} alt='2000' />
						<p
							className={cx({
								box_p: true,
								'text-white text-base px-3 lg:px-6 font-bold text-center': true,
							})}
						>
							COLABORADORES <br />
							<br />
						</p>
					</div>
					<div className='hidden lg:flex  flex-col w-1/2 lg:w-1/5 lg:mx-8 pt-12 justify-center items-center'>
						<CDNImage className='w-full px-2 lg:px-0' image_name={'23b.png'} alt='23' />
						<p
							className={cx({
								box_p: true,
								'text-white text-base px-3 lg:px-6 font-bold text-center': true,
							})}
						>
							CENTROS DE VENTA EN CHILE
						</p>
					</div>
				</div>
				<div className='w-full flex flex-col lg:flex-row'>
					<CDNImage className='w-full hidden lg:flex' image_name={'timeline.png'} alt='23' />
					<CDNImage className='w-full lg:hidden' image_name={'mobile/time-line-mobile.png'} alt='23' />
				</div>
				<div className='hidden lg:flex flex-col lg:flex-row w-full'>
					<div className='flex flex-col w-1/2 pt-12 justify-center items-end'>
						<CDNImage image_name={'panificadora.png'} alt='panificadora' />
					</div>
					<div className='flex flex-col w-1/2 pt-12 justify-center items-start'>
						<CDNImage image_name={'33_paises.png'} alt='33_paises' />
					</div>
				</div>
				<div className='flex flex-col lg:flex-row justify-center items-center w-full '>
					<CDNImage
						image_name={'Alimenta_tu_mundo_promesa_800.png'}
						className='hidden lg:flex'
						alt='Alimenta_tu_mundo_promesa'
					/>
					<CDNImage
						image_name={'mobile/promesa_ideal_mobile.png'}
						className='flex lg:hidden'
						alt='Alimenta_tu_mundo_promesa'
					/>
				</div>
			</div>
			<div className='flex flex-col lg:flex-row p-4 pb-2 lg:p-10 w-full mx-0 lg:m-0'>
				<div className='flex flex-col w-full lg:w-1/2 mx-0 lg:mx-8 pt-12 items-center lg:justify-center lg:items-end'>
					<HoverCard
						background_url='https://tcn-assets.hiperjob.com/ideal/images/conviccion.png'
						text='Nos mueven las causas. Pensamos a futuro y actuamos día a día para generar un impacto positivo en el planeta. Estamos comprometidos con tomar decisiones éticas y responsables para alimentar un mundo mejor.'
					/>
				</div>
				<div className='flex flex-col w-full lg:w-1/2 mx-0 lg:mx-8 pt-4 lg:pt-12 items-center lg:justify-center lg:items-start'>
					<HoverCard
						background_url='https://tcn-assets.hiperjob.com/ideal/images/dinamismo.png'
						text='Nos anticipamos al futuro con agilidad e innovación, y por ello, ofrecemos opciones para todos, desarrollamos productos de calidad superior y promovemos estilos de vida saludables.'
					/>
				</div>
			</div>
			<div className='flex flex-col lg:flex-row p-4 pt-2 lg:p-10 w-full '>
				<div className='flex flex-col w-full lg:w-1/2 mx-0 lg:mx-8 pt-0 lg:pt-12 items-center lg:justify-center lg:items-end'>
					<HoverCard
						background_url='https://tcn-assets.hiperjob.com/ideal/images/sentido_humano.png'
						text='Las personas van al centro de todo lo que hacemos y creemos que tienen el potencial para crecer, aprender y ser mejores. No solo encontramos la manera de alcanzar nuestras metas personales, y profesionales, también buscamos que nuestro trabajo se convierta en nuestra pasión, misión y aventura'
					/>
				</div>
				<div className='flex flex-col w-full lg:w-1/2 mx-0 lg:mx-8 pt-4 lg:pt-12 items-center lg:justify-center lg:items-start'>
					<HoverCard
						background_url='https://tcn-assets.hiperjob.com/ideal/images/apertura.png'
						text='Somos una comunidad, tenemos una visión global y actuamos localmente. Valoramos la diversidad en todas sus formas. Aceptamos las distintas maneras de pensar y generamos un ambiente de confianza porque actuamos de manera incluyente.'
					/>
				</div>
			</div>
		</section>
	);
};

export default We;
